import { useState } from "react";

const duePlans = [
  { id: "monthly", label: "Monthly", amount: "$65", period: "/month" },
  { id: "quarterly", label: "Quarterly", amount: "$180", period: "/quarter", badge: "Save $15" },
  { id: "annual", label: "Annual", amount: "$700", period: "/year", badge: "Save $80" },
];

export default function PayDuesSection() {
  const [selected, setSelected] = useState("monthly");
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="pay-dues" className="w-full bg-[#0d0d0d] py-24 px-6 lg:px-20">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-3">Stay Current</p>
        <h2 className="text-4xl md:text-5xl font-black text-white uppercase mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
          Pay Your Dues
        </h2>
        <p className="text-gray-500 text-sm mb-12 max-w-lg mx-auto">
          Keep your membership active and your colors flying. Dues fund club events, community outreach, and chapter operations.
        </p>

        {/* Plan selector */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
          {duePlans.map((plan) => (
            <button
              key={plan.id}
              onClick={() => setSelected(plan.id)}
              className={`relative p-6 border text-left transition-all duration-200 cursor-pointer ${
                selected === plan.id
                  ? "border-red-600 bg-[#1a0a0a]"
                  : "border-[#2a2a2a] bg-[#1a1a1a] hover:border-gray-600"
              }`}
            >
              {plan.badge && (
                <span className="absolute top-3 right-3 bg-red-700 text-white text-xs px-2 py-0.5 uppercase font-bold">
                  {plan.badge}
                </span>
              )}
              <div className="flex items-center gap-2 mb-3">
                <div className={`w-4 h-4 flex items-center justify-center rounded-full border-2 ${selected === plan.id ? "border-red-600" : "border-gray-600"}`}>
                  {selected === plan.id && <div className="w-2 h-2 rounded-full bg-red-600"></div>}
                </div>
                <span className="text-white text-sm font-semibold uppercase tracking-wider">{plan.label}</span>
              </div>
              <p className="text-3xl font-black text-red-500" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                {plan.amount}
              </p>
              <p className="text-gray-500 text-xs">{plan.period}</p>
            </button>
          ))}
        </div>

        <div className="bg-[#1a1a1a] border border-[#2a2a2a] p-8 mb-8 text-left">
          <h3 className="text-white font-black text-xl uppercase mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>What Your Dues Cover</h3>
          <div className="grid grid-cols-2 gap-3">
            {[
              "Chapter event costs",
              "Club facility maintenance",
              "Community charity rides",
              "Member emergency fund",
              "Legal defense fund",
              "Annual rally expenses",
            ].map((item) => (
              <div key={item} className="flex items-center gap-2 text-gray-400 text-sm">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-red-600"></i>
                </div>
                {item}
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={() => setShowModal(true)}
          className="bg-red-700 hover:bg-red-600 text-white uppercase font-bold tracking-widest px-16 py-4 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          Pay Now
        </button>
        <p className="text-gray-600 text-xs mt-4">Secure payment processing. Questions? Contact your chapter treasurer.</p>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <div className="bg-[#111111] border border-[#2a2a2a] max-w-md w-full p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-white font-black text-2xl uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>Payment Info</h3>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="bg-[#1a0a0a] border border-red-900/50 p-4 rounded-sm mb-6">
              <p className="text-gray-400 text-sm">To complete your dues payment, please contact your chapter treasurer or bring payment to the next chapter meeting. Online payment integration coming soon.</p>
            </div>
            <div className="space-y-3 text-sm text-gray-400">
              <p><span className="text-white font-semibold">Treasurer:</span>&nbsp;Phoenix&nbsp;</p>
              <p><span className="text-white font-semibold">Phone:</span>&nbsp;</p>
              <p><br /></p>
              <p><span className="text-white font-semibold">Cash App:</span>&nbsp;</p>
            </div>
            <button onClick={() => setShowModal(false)} className="mt-6 w-full bg-red-700 hover:bg-red-600 text-white uppercase font-bold tracking-widest py-3 text-sm cursor-pointer whitespace-nowrap">
              Got It
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
